import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";
import type { FieldError, UseFormMethods } from "react-hook-form";
import { alphaNumericRegex } from "itsf-ui-common";
import { countyFormatter } from "@utils/addressFormatter";
import { counties } from "./counties";
import { MenuItem, Typography } from "@mui/material";
import { LabeledTextField } from "@common/LabeledTextField/LabeledTextField";
import { PLACEHOLDER_OPACITY } from "../../theme/themeConfiguration";

interface ICounties {
    control: UseFormMethods["control"];
    error: FieldError | undefined;
    prefix?: string;
}

export const CountiesDropdown = (props: ICounties) => {
    const { t } = useTranslation(["address", "validation"]);
    const { control, error, prefix } = props;

    const namePrefix = prefix ? `${prefix}.` : "";
    const idPrefix = prefix ? `${prefix}-` : "";

    const countiesList = counties.map((county) => ({ value: county, label: countyFormatter(county) }));

    return (
        <Controller
            control={control}
            name={`${namePrefix}county`}
            render={(renderProps) => (
                <LabeledTextField
                    SelectProps={{
                        displayEmpty: true,
                    }}
                    className="xtest_title_input"
                    error={Boolean(error)}
                    fullWidth
                    helperText={error?.message}
                    id={`${idPrefix}counties`}
                    inputRef={renderProps.ref}
                    isRequired
                    labelText={t("address:county")}
                    margin="dense"
                    name={renderProps.name}
                    select
                    value={renderProps.value}
                    onChange={renderProps.onChange}
                >
                    <MenuItem disabled value="">
                        <Typography sx={{ opacity: PLACEHOLDER_OPACITY }}>{t("address:countyPlaceholder")}</Typography>
                    </MenuItem>
                    {countiesList.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </LabeledTextField>
            )}
            rules={{
                required: t("validation:required"),
                pattern: { value: alphaNumericRegex, message: t("validation:onlyLettersNumbers") },
            }}
        />
    );
};
